module.exports = __webpack_public_path__ + "img/page-intro-logo-baserow.a0badce.svg";